import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccordionService {

  private _expand$: Subject<string> = new Subject();

  constructor() { }

  public get onExpand(): Observable<string> {
    return this._expand$.asObservable();
  }

  public expandById(id: string): void {
    this._expand$.next(id);
  }
  
}
